import React from 'react';

function ComingSoon() {

  return (
    <div >
      <div className="hero-banner" >
        <div className="hero-content" >
        <br></br><br></br><br></br>
          <h1>Coming Soon</h1>
          <br></br><br></br><br></br><br></br><br></br>
          <h2>Page under construction</h2>
          <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
        </div>
        <br></br><br></br>
      </div>

     
    </div>
  );
}

export default ComingSoon;
